import { useContext } from "react";
import { BreweryModalContext } from "../context/BreweryModalContext";

const noop = () => {};

export const defaultModalContext = {
  modals: {
    brew: { isOpen: false, selectedDevice: "", selectedRecipe: "" },
    wifi: { isOpen: false },
    cleaning: { isOpen: false, deviceUUID: undefined, cleaningType: null },
    device: { isOpen: false, selectedSerialNumber: 0 },
    stopSession: { isOpen: false, selectedSession: 0 },
    resetSession: { isOpen: false, selectedSession: 0 },
    addDevice: { isOpen: false },
    unregister: { isOpen: false, deviceUUID: null },
    acidSupport: { isOpen: false },
    editFermentation: { isOpen: false, fermentationDevice: null },
  },
  actions: {
    openBrewModal: noop,
    closeBrewModal: noop,
    openWifiModal: noop,
    closeWifiModal: noop,
    toggleCleaningModal: noop,
    toggleAcidCleaningModal: noop,
    closeCleaningModal: noop,
    openDeviceModal: noop,
    closeDeviceModal: noop,
    openStopSessionModal: noop,
    closeStopSessionModal: noop,
    openResetSessionModal: noop,
    closeResetSessionModal: noop,
    openAddDeviceModal: noop,
    closeAddDeviceModal: noop,
    openUnregisterDeviceModal: noop,
    closeUnregisterDeviceModal: noop,
    openAcidSupportModal: noop,
    closeAcidSupportModal: noop,
    openEditFermentationModal: noop,
    closeEditFermentationModal: noop,
    showModal: noop,
    showWifiModal: noop,
    showDeviceModal: noop,
    showCleaningModal: noop,
    showStopSessionModal: noop,
    showResetSessionModal: noop,
    showAddDeviceModal: noop,
    showUnregisterDeviceModal: noop,
    showAcidSupportModal: noop,
    showEditFermentationModal: noop,
  },
};

export function useBreweryModalContext() {
  const context = useContext(BreweryModalContext);
  return context || defaultModalContext;
}

export default useBreweryModalContext;
